import { Button, ButtonGroup, Segment } from 'semantic-ui-react';
import Alert from '../../../../../utils/alert';
import ImportsRepo from '../../../../../utils/repository/importsRepo';
import { BLOCK_TYPE, COLUMN_TYPE } from '../../constants/generalConstants';
import { RESPONSE_STATUS } from '../../../../../constnats/general';
import useModalState from '../../../../../hooks/useModalState';
import { useMetadataStoreState } from '../../stores/metadataStore';
import { ExtractionType, TableBlockType } from '../../types';
import { validateReports, validateTables } from './utils';
import './../../tableExtraction.styles.css';
import './annotations.styles.css';
import AnnotationsBlocks from './components/annotationsBlocks';
import GlobalAnnotations from './components/globalAnnotations';
import AnnotationsSaveModal from './components/annotationsSaveModal';
import { useState } from 'react';
import BrowserStorage from '../../../../../utils/browserStorage';

type AnnotationsPropsType = {
    extraction: ExtractionType;
    setExtraction: (extraction: ExtractionType) => void;
    handleDeleteImport: () => void;
};
function Annotations({ extraction, setExtraction, handleDeleteImport }: AnnotationsPropsType) {
    const { rowsMetadata, colsMetadata, numberFormat, scale, financialSource } = useMetadataStoreState();
    const saveModalState = useModalState();
    const [loading, setLoading] = useState(false);

    const handleMetadataSave = () => {
        setLoading(true);
        saveModalState.closeModal();
        const colsMetadataToSave = colsMetadata.map((colMetadata) => {
            if (colMetadata.contentType !== COLUMN_TYPE.REPORT) {
                const { reportProps, ...rest } = colMetadata;
                return {
                    ...rest,
                };
            } else {
                return colMetadata;
            }
        });

        const reportsMetadata = colsMetadata
            .filter((cols) => cols.contentType === COLUMN_TYPE.REPORT)
            .filter((x) => x.importCandidate);
        const reportsError = validateReports(reportsMetadata);
        if (reportsError.error) {
            Alert.warn(reportsError.message);
            setLoading(false);
            return;
        }

        const tables = extraction.document.blocks.filter(
            (block) => block.type === BLOCK_TYPE.TABLE
        ) as TableBlockType[];
        const tableErrors = validateTables(tables, rowsMetadata, colsMetadata);
        if (tableErrors.error) {
            Alert.warn(tableErrors.message);
            setLoading(false);
            return;
        }
        // TODO:here there should also be an object containing the scales for each table
        // is this still relevant
        // changes have been made to have global scale for all tables

        ImportsRepo.metadataUpdate(
            extraction.id,
            { colAnnotations: colsMetadataToSave, rowAnnotations: rowsMetadata, numberFormat, scale, financialSource },
            // fix types
            (response: any) => {
                if (response.status === RESPONSE_STATUS.SUCCESS) {
                    setExtraction(response.data);
                    setLoading(false);
                    Alert.success('Metadata successfully saved');
                    BrowserStorage.setLabelsNormalizationStatus(extraction.id, false)
                } else {
                    setLoading(false);
                    Alert.error(`ERROR: ${response.message}`);
                }
            }
        );
    };

    return (
        <Segment className="annotations">
            <GlobalAnnotations />
            <AnnotationsBlocks blocks={extraction.document.blocks} />
            <ButtonGroup fluid>
                <Button disabled={loading} loading={loading} primary onClick={saveModalState.openModal}>
                    Save
                </Button>
                <Button negative onClick={handleDeleteImport}>
                    Delete
                </Button>
            </ButtonGroup>
            <AnnotationsSaveModal
                open={saveModalState.open}
                onClose={saveModalState.closeModal}
                handleSave={handleMetadataSave}
            />
        </Segment>
    );
}

export default Annotations;
